var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuelResizeable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fuel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCC6-Make-a-reservation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-729.000000, -1131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local_gas_station_black_24dp",
    transform: "translate(729.000000, 1131.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.77,7.23 L19.78,7.22 L16.59,4.03 C16.3,3.74 15.82,3.74 15.53,4.03 C15.24,4.32 15.24,4.8 15.53,5.09 L17.11,6.67 C16.06,7.07 15.35,8.14 15.53,9.38 C15.69,10.48 16.63,11.37 17.73,11.49 C18.2,11.54 18.61,11.46 19,11.29 L19,18.5 C19,19.05 18.55,19.5 18,19.5 C17.45,19.5 17,19.05 17,18.5 L17,14 C17,12.9 16.1,12 15,12 L14,12 L14,5 C14,3.9 13.1,3 12,3 L6,3 C4.9,3 4,3.9 4,5 L4,20 C4,20.55 4.45,21 5,21 L13,21 C13.55,21 14,20.55 14,20 L14,13.5 L15.5,13.5 L15.5,18.36 C15.5,19.67 16.44,20.86 17.74,20.99 C19.24,21.14 20.5,19.97 20.5,18.5 L20.5,9 C20.5,8.31 20.22,7.68 19.77,7.23 Z M12,10 L6,10 L6,6 C6,5.45 6.45,5 7,5 L11,5 C11.55,5 12,5.45 12,6 L12,10 Z M18,10 C17.45,10 17,9.55 17,9 C17,8.45 17.45,8 18,8 C18.55,8 19,8.45 19,9 C19,9.55 18.55,10 18,10 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelResizeable);
export default __webpack_public_path__ + "static/media/fuel_resizeable.3a2ed3df80a228ec9ccc1da8645cb3f4.svg";
export { ForwardRef as ReactComponent };